module.exports = __webpack_public_path__ + "img/shopping-ctaBtn.3c36eb8b.svg";